import { RestartCircleIconSvg } from "@/assets/svg";
import PauseCircleSvg from "@/assets/svg/PauseCircleIconSvg";
import PlayCircleSvg from "@/assets/svg/PlayCircleIconSvg";
import Icon from "@ant-design/icons";
import { Tooltip, Switch } from "antd";
import dayjs from "dayjs";
import { usePlayerChart } from "@/components/General/PlayerChart/context/usePlayerChart";

export default function DrawerHeaderWithControls({ 
    title, 
    onClose
}: { 
    title: string;
    onClose?: () => void;
}) {
    const {
        isPlaying,
        currentIndex,
        totalTimestamps,
        maxTimestamp,
        minTimestamp,
        handlePlay,
        handleStop,
        handleReset,
    } = usePlayerChart();

    const isAtEnd = currentIndex >= totalTimestamps - 1;

    return (
        <div className="relative flex items-center justify-between w-full gap-2">
           
            <div className="flex-shrink-0">
                <h3 className="text-base font-medium text-gray-800">{title}</h3>
            </div>

       
            <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-2 z-10">
                {!isAtEnd ? (
                    <>
                 
                        <Tooltip title={isPlaying ? 'Pause' : 'Play'}>
                            <Icon
                                component={isPlaying ? PauseCircleSvg : PlayCircleSvg}
                                className="control-button"
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    fontSize: '28px',
                                    color: '#22c55e',
                                    cursor: 'pointer',
                                }}
                                onClick={isPlaying ? handleStop : handlePlay}
                            />
                        </Tooltip>

              
                        {isPlaying && (
                            <Tooltip title="Reset to start">
                                <Icon
                                    component={RestartCircleIconSvg}
                                    className="control-button"
                                    style={{
                                        width: '28px',
                                        height: '28px',
                                        fontSize: '28px',
                                        color: '#3b82f6',
                                        cursor: 'pointer',
                                    }}
                                    onClick={handleReset}
                                />
                            </Tooltip>
                        )}
                    </>
                ) : (

                    <Tooltip title="Replay">
                        <Icon
                            component={RestartCircleIconSvg}
                            className="control-button"
                            style={{
                                width: '28px',
                                height: '28px',
                                fontSize: '28px',
                                color: '#3b82f6',
                                cursor: 'pointer',
                            }}
                            onClick={handleReset}
                        />
                    </Tooltip>
                )}
            </div>

            <div className="flex items-center gap-3 flex-shrink-0">
                <Tooltip title="To change the date range, use the calendar button icon in the header">
                    <div className="text-xs text-gray-600 text-right">
                        <div className="font-medium">
                            From: {dayjs(minTimestamp).format('YYYY-MM-DD hh:mm A')}
                        </div>
                        <div className="font-medium">
                            To: {dayjs(maxTimestamp).format('YYYY-MM-DD hh:mm A')}
                        </div>
                    </div>
                </Tooltip>
                
                {onClose && (
                    <Switch
                        checked={true}
                        onChange={() => onClose()}
                        checkedChildren="Hide Playback"
                        unCheckedChildren="Hide Playback"
                        size="default"
                    />
                )}
            </div>
        </div>
    );
}
